import React from 'react'
import Slider from 'react-slick'
import type { Settings as ReactSlickSettings } from 'react-slick'
import { useTranslation } from 'next-i18next'
import cn from 'classnames'
import s from '@corratech/pylot-upsell/src/Upsell.module.scss'
import { ProductInterface } from '@pylot-data/fwrdschema'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Link from 'next/link'

const settings = {
    arrows: true,
    speed: 400,
    slidesToScroll: 5,
    slidesToShow: 5,
    draggable: true,
    infinite: false,
    dots: false,
    fade: false,
    prevArrow: <button type="button" className="slick-prev" />,
    nextArrow: <button type="button" className="slick-next" />,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                dots: true,
                arrows: false
            }
        }
    ]
} as ReactSlickSettings

export interface UpsellProps {
    ProductTile: React.ElementType
    products: [ProductInterface]
    productToShow: number
    sliderSettings: ReactSlickSettings
    title?: string
    className?: string
    gtmLocation?: string
}

export const CrossShell = ({
    ProductTile,
    products,
    productToShow,
    sliderSettings,
    title,
    className,
    gtmLocation
}: UpsellProps): JSX.Element | null => {
    const { t } = useTranslation('common')
    const isMobile = useIsMobile()

    const renderProducts = () => {
        return products
            .slice(0, productToShow)
            .map((product: ProductInterface, index: number) => {
                return (
                    <div
                        className={cn(s['product-item'], 'upsell-product-item')}
                        key={index}
                    >
                        <ProductTile
                            product={product}
                            gtmLocation={gtmLocation}
                        />
                    </div>
                )
            })
    }
    return (
        <>
            {products?.length > 0 && (
                <div className={cn(s['upsell-products'], className)}>
                    <div
                        className={cn(
                            s['heading-container'],
                            'upsell-heading-container'
                        )}
                    >
                        <h2 className={cn(s['title'], 'upsell-title')}>
                            {title ? title : t('YOU MIGHT ALSO LIKE')}
                        </h2>
                    </div>
                    <div
                        className={cn(
                            s['products-list'],
                            'upsell-products-list'
                        )}
                    >
                        <Slider {...sliderSettings}>{renderProducts()}</Slider>
                    </div>
                </div>
            )}
        </>
    )
}

CrossShell.defaultProps = {
    productToShow: 16,
    sliderSettings: settings
}
